import React, { FC } from 'react';
import { Space } from 'udesk-ui';
import CustomModelsSelect from 'src/components/common/CustomModelsSelect';
import CustomModelsQaMethod from 'src/components/common/CustomModelsQaMethod';
import TicketRelateQa from 'src/components/common/TicketRelateQa';
import { AiModelFoundResponse } from 'src/api/types';

interface TemplateProps {
    value?: {
        aiModel?: AiModelFoundResponse;
        aiBatchQa?: number;
        ticketRelateQa?: number;
    };
    onChange?: (v: TemplateProps['value']) => void;
    type?: number;
    disabled?: boolean;
    showCustomModelsQaMethod?: boolean;
}

const Template: FC<TemplateProps> = (props) => {
    const { value, onChange, type, disabled, showCustomModelsQaMethod } = props;

    return (
        <Space align="baseline">
            <CustomModelsSelect
                value={value?.aiModel?.id}
                onChange={(v) => onChange?.({ ...value, aiModel: v })}
                type={type}
                disabled={disabled}
            />

            {showCustomModelsQaMethod ? (
                <CustomModelsQaMethod
                    value={value?.aiBatchQa}
                    onChange={(v) => onChange?.({ ...value, aiBatchQa: v })}
                    disabled={disabled}
                />
            ) : null}

            <TicketRelateQa
                value={value?.ticketRelateQa}
                onChange={(v) => onChange?.({ ...value, ticketRelateQa: v })}
                disabled={disabled}
            />
        </Space>
    );
};

export default Template;
